module.exports = __webpack_public_path__ + "static/media/weather-city.40382ff2.jpg";